import { PdChatItem } from "./PdChatItem.js";
//#region src/pd-chat/pd-chat-item.ts
var tag = "pd-chat-item";
if (!customElements.get(tag)) customElements.define(tag, PdChatItem);
//#endregion
export { PdChatItem };
